/**
 * WordPress Dependencies
 */
import { useDispatch } from '@wordpress/data';
const useGoToBlock = blockId => {
  const {
    goToBlock
  } = useDispatch('quillForms/renderer-core');
  return goToBlock(blockId);
};
export default useGoToBlock;
//# sourceMappingURL=use-go-to-block.js.map